import { translations } from './translations';

export default translations('en');
